import React from 'react';
import Icon from '@components/atoms/icon/icon';
import Button from '@components/atoms/button/button';
import { useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import { CatalogCategoryHotfilterContext } from '@context/catalog-category-hotfilter.context';
import styles from './category-hotfilter-header.module.scss';

const CategoryHotfilterHeader: React.FC = () => {
  const { t } = useTranslation();
  const { t: tA11y } = useTranslation('a11y');
  const parentLevel = useContextSelector(CatalogCategoryHotfilterContext, (context) => context.parentLevel);
  const menuState = useContextSelector(CatalogCategoryHotfilterContext, (context) => context.menuState);
  const setMenuState = useContextSelector(CatalogCategoryHotfilterContext, (context) => context.setMenuState);

  const handleBackClick = () => {
    if (parentLevel) {
      setMenuState((prev) => ({
        ...prev,
        activeLevel: parentLevel,
        [menuState.activeLevel]: null,
      }));
    }
  };

  const title = menuState[parentLevel]?.name ?? t('CATALOG.FILTERS.UNIVERSE');

  return (
    <div className={styles.categoryHotfilterHeader}>
      {menuState.activeLevel !== menuState.firstLevel && (
        <Button
          disableDefaultStyling
          onClick={handleBackClick}
          className={styles.categoryHotfilterHeader__backButton}
          aria-label={tA11y('A11Y.ICON.BACK')}
        >
          <Icon
            name="arrow-right-long-20"
            ariaHidden
          />
        </Button>
      )}
      <h3 className={styles.categoryHotfilterHeader__title}>{title}</h3>
    </div>
  );
};

export default CategoryHotfilterHeader;
